// 计费单

import { HttpGetInventoryAging,HttpGetInventoryAgingExport } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},

            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryAging,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
              /*   HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    }); */
            }

        },
        interceptRequest(params) {
            const search = params.search
            // params.search.EQ_organizationId = this.isAdmin() ? '' : global.SYSID;
            params.state = this.isAdmin() ? '1' : '0';
           /*  params.search.IN_warehouseType = this.isAdmin() ? '1,4,5' : '1,2,4,5'; */
            this.formData.state = params.state;
          /*   if(params.search.EQ_productType){
                params.productType = params.search.EQ_productType;
                delete params.search.EQ_productType;
            } */
            if (params.search.IN_warehouseId) {
                params.warehouseIds = params.search.IN_warehouseId;
                this.formData.warehouseIds = params.search.IN_warehouseId;
                delete params.search.IN_warehouseId;
                delete params.search.IN_warehouseId;
                // console.log(params)
                return params
            } else {
                return params
            }
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryAgingExport, this.formData, 'download')
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerAge';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList','getSelfmanageorgList', 'getBillcusorgList', 'getCusproductList', 'getSystemWareList', 'getAdminTransferWarehouse','getTransferWarehouse']),
        // ...mapGetters('common', ['getInventoryType', 'getProductType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: this.isAdmin() ? 'IN_orgWarehouseCode' : 'IN_orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    default: this.$route.query.erpsku,
                    tag: 'vInput',
                },
                {
                    label: this.$t('erp.setting.goods_type', { defaultValue: "产品类型" }),
                    key: 'EQ_productType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getProductType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    show: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    render: (h, { row }) =>
                    this.findRenderLabel(
                        this.isAdmin() ? this.getCusproductList : this.getProductList,
                        row.lineId
                    )
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('erp.setting.goods_type', { defaultValue: '产品类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let productType = row.productType
                        const { label } = this.getProductType.find(function (item) {
                            return item.value == productType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('erp.product.current', { defaultValue: '总库存' }),
                    key: 'inventoryCurrent',
                    sortable: true
                },
                {
                    title: this.$t('fbb.inventory.day_stock_number', { defaultValue: '天-库存数量(7/30/60/90/120/180/180-270/360/360以上)' }),
                    render:(h, { row }) => {

                        return <div><div>{row.inventoryDay7}</div><div>{row.inventoryDay30}</div><div>{row.inventoryDay60}</div><div>{row.inventoryDay90}</div><div>{row.inventoryDay120}</div><div>{row.inventoryDay180}</div>
                        <div>{row.inventoryDay270}</div><div>{row.inventoryDay360}</div><div>{row.inventoryMore360}</div></div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.day_stock_volumn', { defaultValue: '天-库存体积(7/30/60/90/120/180/180-270/360/360以上)' }),
                    render:(h, { row }) => {

                        return <div><div>{row.inventoryVolDay7}</div><div>{row.inventoryVolDay30}</div><div>{row.inventoryVolDay60}</div><div>{row.inventoryVolDay90}</div><div>{row.inventoryVolDay120}</div><div>{row.inventoryVolDay180}</div>
                        <div>{row.inventoryVolDay270}</div><div>{row.inventoryVolDay360}</div><div>{row.inventoryVoMore360}</div></div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.product_value', { defaultValue: '产品价值' }),
                    key: 'fobPrice',

                },
                {
                    title: this.$t('erp.product_channel.currency', { defaultValue: '币种' }),
                    key: 'currency',

                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                       /*  var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          } */
                          return <div>{row.length}*{row.width}*{row.height}</div>
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                       /*  var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                         */
                        return <div>{row.weight}</div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




